import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import FollowupsReportLayer from '../components/reports/FollowupsReportLayer'

export const FollowupsReportPage = () => {
  return (
                                            <MasterLayout>
        <FollowupsReportLayer />
    </MasterLayout>
    );
};

export default FollowupsReportPage;